import { Api } from '@monorepo/shared/apiClient';
import { useMutation } from 'react-query';

export function useDeleteTask() {
  return useMutation(Api.deleteTask);
}
